import { Module } from 'vuex'
import { AuthState, LoginPayload, RegisterPayload, User } from '@/types'

const auth: Module<AuthState, unknown> = {
  namespaced: true,

  state: (): AuthState => ({
    user: (() => {
      try { return JSON.parse(localStorage.getItem('jh_user') || 'null') } catch { return null }
    })(),
    token: localStorage.getItem('jh_token'),
    loading: false,
    error: null
  }),

  getters: {
    isAuthenticated: (state) => !!state.token && !!state.user,
    isAdmin: (state) => state.user?.role === 'admin',
    isVendor: (state) => state.user?.role === 'vendor',
    currentUser: (state) => state.user
  },

  mutations: {
    SET_LOADING (state, loading: boolean) {
      state.loading = loading
    },
    SET_ERROR (state, error: string | null) {
      state.error = error
    },
    SET_AUTH (state, { user, token }: { user: User; token: string }) {
      state.user = user
      state.token = token
      localStorage.setItem('jh_token', token)
      localStorage.setItem('jh_user', JSON.stringify(user))
    },
    CLEAR_AUTH (state) {
      state.user = null
      state.token = null
      localStorage.removeItem('jh_token')
      localStorage.removeItem('jh_user')
    }
  },

  actions: {
    async login ({ commit }, payload: LoginPayload) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        // TODO: replace with real API call
        await new Promise(resolve => setTimeout(resolve, 800))
        const mockUser: User = {
          id: '1',
          name: 'Demo User',
          email: payload.email,
          role: payload.email.includes('admin') ? 'admin' : 'customer',
          createdAt: new Date().toISOString()
        }
        commit('SET_AUTH', { user: mockUser, token: 'mock_token_' + Date.now() })
      } catch (err) {
        commit('SET_ERROR', 'Invalid email or password')
        throw err
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async register ({ commit }, payload: RegisterPayload) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)
      try {
        await new Promise(resolve => setTimeout(resolve, 800))
        const mockUser: User = {
          id: Date.now().toString(),
          name: payload.name,
          email: payload.email,
          role: 'customer',
          phone: payload.phone,
          createdAt: new Date().toISOString()
        }
        commit('SET_AUTH', { user: mockUser, token: 'mock_token_' + Date.now() })
      } catch (err) {
        commit('SET_ERROR', 'Registration failed. Please try again.')
        throw err
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async fetchCurrentUser ({ commit, state }) {
      if (!state.token) return
      // If user is already hydrated from localStorage, skip the mock fetch
      if (state.user) return
      commit('SET_LOADING', true)
      try {
        // TODO: replace with GET /auth/me
        await new Promise(resolve => setTimeout(resolve, 300))
        const mockUser: User = {
          id: '1',
          name: 'Demo User',
          email: 'demo@jengahills.com',
          role: 'customer',
          createdAt: new Date().toISOString()
        }
        commit('SET_AUTH', { user: mockUser, token: state.token })
      } finally {
        commit('SET_LOADING', false)
      }
    },

    logout ({ commit }) {
      commit('CLEAR_AUTH')
    }
  }
}

export default auth
